import React, { FC, useState } from 'react';
import { MutationFunction } from 'react-apollo';
import { Formik, Form, FormikHelpers } from 'formik';
import { createStyles, Theme, withStyles, WithStyles } from '@material-ui/core/styles';

import {
  ClientFollowMappingStatus,
  CreateClientFollowMappingComponent,
  GetAllClientFollowMappingsDocument,
  CreateClientFollowMappingInput,
} from 'api';
import { useNotify } from 'hooks';
import { OnboardingSchema } from 'features/admin/validations';
import { createClientFollowMapping } from 'apollo/reducers';
import { createClientFollowMappingResponse } from 'apollo/responses';

import Title from './Title';

const EMPTY_MAPPING: CreateClientFollowMappingInput = {
  title: '',
  all_users: false,
  mapping_status: ClientFollowMappingStatus.Disabled,
};

const styles = (theme: Theme) =>
  createStyles({
    paper: {
      padding: theme.spacing(2),
      marginTop: theme.spacing(4),
      marginBottom: theme.spacing(4),
    },
  });

const Custom: FC<WithStyles<typeof styles>> = () => {
  const [working, setWorking] = useState(false);
  const notify = useNotify();

  function handleCreate(
    mutation: MutationFunction,
    values: CreateClientFollowMappingInput,
    formikActions: FormikHelpers<CreateClientFollowMappingInput>,
  ) {
    mutation({
      variables: { data: values },
      update: (cache, result) => {
        createClientFollowMapping({
          cache,
          result,
          query: GetAllClientFollowMappingsDocument,
          variables: { data: {} },
        });
      },
      optimisticResponse: createClientFollowMappingResponse(values),
    });

    formikActions.resetForm();
    setWorking(true);
  }

  function createNotify() {
    notify.info({ i18n: { i18nKey: 'common:saved' } });
    setWorking(false);
  }

  return (
    <CreateClientFollowMappingComponent onError={notify.mutationError} onCompleted={createNotify}>
      {mutation => (
        <Formik
          initialValues={EMPTY_MAPPING}
          onSubmit={(values, formikActions) => handleCreate(mutation, values, formikActions)}
          validationSchema={OnboardingSchema}
          render={() => (
            <Form>
              <Title working={working} activeIcon={false} i18nKey="common:add" />
            </Form>
          )}
        />
      )}
    </CreateClientFollowMappingComponent>
  );
};

export default withStyles(styles)(Custom);
